<div class="min-h-screen bg-gray-100 dark:bg-transparent rounded-lg p-6 transition-colors duration-300">
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <div>
            <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Gestión de Tareas</h1>
            <p class="text-sm text-gray-500 dark:text-gray-400">Visualiza y organiza tus compromisos comerciales</p>
        </div>

        <div class="flex bg-white dark:bg-gray-800 rounded-lg p-1 shadow-sm border border-gray-200 dark:border-gray-700">
            <button (click)="vistaLista()"
                class="px-4 py-2 text-sm font-medium rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                Lista
            </button>
            <button (click)="vistaKanban()"
                class="px-4 py-2 text-sm font-medium rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                Kanban
            </button>
            <button (click)="vistaCalendario()"
                class="px-4 py-2 text-sm font-medium rounded-md bg-brand-50 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400 shadow-sm">
                Calendario
            </button>
        </div>
    </div>

    <div class="bg-white dark:bg-gray-900 dark:border-gray-700 rounded-t-xl p-4 border-b dark:border-gray-700 flex flex-wrap justify-between items-center gap-4 shadow-sm">
        <div class="flex items-center gap-4">
            <div class="flex bg-gray-50 dark:bg-gray-800 rounded-lg p-1 border dark:border-gray-700">
                <button (click)="setOwnerFilter('all')"
                    class="px-3 py-1.5 text-xs font-medium rounded-md transition-all"
                    [class.bg-white]="ownerFilter === 'all'"
                    [class.dark:bg-gray-700]="ownerFilter === 'all'"
                    [class.text-brand-600]="ownerFilter === 'all'"
                    [class.shadow-sm]="ownerFilter === 'all'"
                    [class.text-gray-500]="ownerFilter !== 'all'">Todas</button>
                <button (click)="setOwnerFilter('mine')"
                    class="px-3 py-1.5 text-xs font-medium rounded-md transition-all"
                    [class.bg-white]="ownerFilter === 'mine'"
                    [class.dark:bg-gray-700]="ownerFilter === 'mine'"
                    [class.text-brand-600]="ownerFilter === 'mine'"
                    [class.shadow-sm]="ownerFilter === 'mine'"
                    [class.text-gray-500]="ownerFilter !== 'mine'">Mis Tareas</button>
            </div>
            <div class="flex items-center bg-gray-50 dark:bg-gray-800 rounded-lg border dark:border-gray-700 p-1">
                <button (click)="prevMonth()" class="px-3 py-1.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-white dark:hover:bg-gray-700 rounded-md transition">
                    ← Anterior
                </button>
                <h2 class="px-4 font-bold text-gray-700 dark:text-gray-200 min-w-[140px] text-center capitalize">
                    {{ getMonthName() }} {{ currentYear }}
                </h2>
                <button (click)="nextMonth()" class="px-3 py-1.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-white dark:hover:bg-gray-700 rounded-md transition">
                    Siguiente →
                </button>
            </div>
        </div>

        <div class="flex items-center gap-3">
            <button (click)="nuevaTarea()"
                class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                </svg>
                Nueva Tarea
            </button>
        </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-12 gap-0 border-x border-b dark:border-gray-700 rounded-b-xl overflow-hidden shadow-lg">

        <div class="lg:col-span-8 bg-white dark:bg-gray-900">
            <div class="grid grid-cols-7 bg-gray-50 dark:bg-gray-800 border-b dark:border-gray-700">
                @for (d of ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb']; track d) {
                    <div class="py-3 text-[11px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider text-center">
                        {{ d }}
                    </div>
                }
            </div>

            <div class="grid grid-cols-7">
                @for (day of days; track day.date.toISOString()) {
                    <div (click)="selectDate(day.date)" (dblclick)="nuevaTareaEnFecha(day.date)"
                        class="h-32 p-1 border-r border-b dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20 transition cursor-pointer relative"
                        [class.bg-blue-50/50]="day.isToday" [class.dark:bg-blue-900/30]="day.isToday"
                        [class.bg-gray-50/30]="!day.isCurrentMonth" [class.dark:bg-gray-800/40]="!day.isCurrentMonth">

                        <div class="flex justify-between items-center p-1">
                            <span class="text-sm font-medium text-gray-700 dark:text-gray-200"
                                [class.!text-blue-600]="day.isToday"
                                [class.dark:!text-blue-400]="day.isToday"
                                [class.!text-gray-300]="!day.isCurrentMonth"
                                [class.dark:!text-gray-600]="!day.isCurrentMonth">
                                {{ day.number }}
                            </span>
                            @if (day.hasOverdue) {
                                <span class="w-2 h-2 bg-red-500 rounded-full" title="Tareas vencidas"></span>
                            }
                        </div>

                        <div class="space-y-1 mt-1 overflow-hidden">
                            @for (task of day.tasks.slice(0, 3); track task.id) {
                                <div (click)="abrirDetalle(task.id!); $event.stopPropagation()"
                                    class="px-2 py-1 text-[10px] rounded border-l-4 truncate shadow-sm hover:brightness-95 transition"
                                    [ngClass]="getPriorityStyles(task)">
                                    <div class="flex items-center gap-1">
                                        <span class="font-bold truncate ">{{ task.title }}</span>
                                    </div>
                                </div>
                            }
                            @if (day.tasks.length > 3) {
                                <div class="text-[9px] text-center text-blue-500 dark:text-blue-400 font-bold pt-1">
                                    +{{ day.tasks.length - 3 }} más
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>

        <div class="lg:col-span-4 bg-gray-50 dark:bg-gray-900 border-l dark:border-gray-700 p-6">
            @if (selectedDate) {
                <div class="mb-6">
                    <h3 class="text-lg font-bold text-gray-800 dark:text-white capitalize">{{ selectedDate | date:'fullDate' }}</h3>
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ selectedTasks.length }} tareas para este día</p>
                </div>

                <div class="space-y-4 overflow-y-auto max-h-[calc(100vh-350px)] pr-2">
                    @for (task of selectedTasks; track task.id) {
                        <div (click)="abrirDetalle(task.id!)"
                            class="bg-white dark:bg-gray-800 p-4 rounded-xl border dark:border-gray-700 shadow-sm hover:shadow-md transition group cursor-pointer">

                            <div class="flex justify-between items-start mb-2">
                                @if (task.priority) {
                                    <span class="px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-tighter"
                                        [ngClass]="getPriorityStyles(task)">
                                        {{ task.priority.label }}
                                    </span>
                                }

                            </div>

                            <h4 class="font-bold text-gray-800 dark:text-white text-sm group-hover:text-blue-600 dark:group-hover:text-blue-400 transition">
                                {{ task.title }}
                            </h4>
                            @if (task.description) {
                                <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 line-clamp-2">{{ task.description }}</p>
                            }

                            <div class="mt-4 flex flex-wrap gap-2 border-t dark:border-gray-700 pt-3">
                                <div class="flex items-center gap-1 text-[10px] text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                    {{ associationLabel(task) }}
                                </div>
                                @if (task.status) {
                                    <div class="flex items-center gap-1 text-[10px] text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                        {{ task.status.label }}
                                    </div>
                                }
                            </div>

                            <div class="mt-3 flex justify-end gap-2 opacity-0 group-hover:opacity-100 transition">
                                <button (click)="editarTarea(task); $event.stopPropagation()"
                                    class="text-[10px] font-bold text-blue-600 dark:text-blue-400 hover:underline">Editar</button>
                                @if (!resolveStatus(task)?.isFinal) {
                                    <button (click)="completarTarea(task, $event)"
                                        class="text-[10px] font-bold text-green-600 dark:text-green-400 hover:underline">Completar</button>
                                }
                            </div>
                        </div>
                    }

                    @if (selectedTasks.length === 0) {
                        <div class="text-center py-12">
                            <p class="text-sm text-gray-400 dark:text-gray-500">Día libre de tareas</p>
                            <button (click)="nuevaTareaEnFecha(selectedDate)"
                                class="mt-3 px-3 py-1.5 text-xs rounded-md bg-brand-500 text-white hover:bg-brand-600">
                                + Crear tarea aquí
                            </button>
                        </div>
                    }
                </div>
            }
        </div>

    </div>
</div>

<!-- El drawer de tarea NO se monta aquí: AppLayout ya monta <app-task-form-drawer />
     globalmente y TaskDrawerService es providedIn:'root'. Montarlo otra vez creaba una
     segunda instancia suscrita al mismo state$ (dos formularios superpuestos). -->
<app-task-detail-modal [isOpen]="showDetailModal" [taskId]="detailTaskId" (closed)="cerrarDetalle()"
    (changed)="onDetailChanged()" />